import React from "react";
import { LegalHero, LegalBody, H2, LastUpdated } from "./legalHelpers";
import { usePageMeta } from "../components/Layout";

export default function FreeDesignTermsPage() {
    usePageMeta({
        title: "Free Design Terms | London Renovation Specialists",
        description: "The terms on which London Renovation Specialists provides its free design service.",
    });
    return (
        <div data-testid="free-design-terms-page">
            <LegalHero
                eyebrow="Terms"
                title="Free Design Terms"
                intro="The terms on which London Renovation Specialists provides its free design service."
            />
            <LegalBody>
                <LastUpdated />

                <H2>Offer</H2>
                <p>
                    The free design service is offered subject to project feasibility. We reserve the right to
                    decline projects that are not suitable for the free service.
                </p>

                <H2>Eligible projects</H2>
                <p>The free design service applies to residential:</p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>rear extensions;</li>
                    <li>side extensions;</li>
                    <li>loft conversions and loft extensions;</li>
                    <li>internal reconfigurations.</li>
                </ul>

                <H2>Scope</H2>
                <p>
                    The service covers architectural concept and layout development through to a level of detail
                    typically prepared for a planning application. The precise scope will depend on the property
                    and the proposed works.
                </p>

                <H2>Surveys</H2>
                <p>
                    Where suitable, a measured survey may be included as part of the free design service. This
                    will depend on the project location, the property and the scope of works.
                </p>

                <H2>Exclusions</H2>
                <p>Unless expressly agreed in writing, the free design service does not include:</p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>structural engineering;</li>
                    <li>structural calculations;</li>
                    <li>Building Regulations packages;</li>
                    <li>technical construction drawings;</li>
                    <li>Party Wall services;</li>
                    <li>Thames Water / build-over applications;</li>
                    <li>specialist consultant reports;</li>
                    <li>specialist planning services;</li>
                    <li>heritage reports;</li>
                    <li>statutory or application fees;</li>
                    <li>Building Control fees;</li>
                    <li>specifications;</li>
                    <li>tender packages;</li>
                    <li>detailed interior design;</li>
                    <li>contract administration.</li>
                </ul>

                <H2>Planning</H2>
                <p>
                    Planning submission and planning management are not automatically included in the free design
                    service. No planning permission or statutory approval is guaranteed as part of the service.
                </p>

                <H2>Construction</H2>
                <p>
                    There is no obligation to appoint London Renovation Specialists to carry out the construction
                    works.
                </p>
                <p>
                    No retrospective design fee becomes payable simply because another contractor is subsequently
                    appointed to build the project.
                </p>

                <H2>Drawings</H2>
                <p>
                    The drawings issued as part of the free design service are architectural concept and
                    planning-level information and are not automatically suitable for construction. Appropriate
                    technical, structural and Building Regulations information may be required before construction
                    work starts.
                </p>

                <H2>Copyright and licence</H2>
                <p>Copyright in the drawings remains with the designer.</p>
                <p>
                    Once issued, the homeowner receives a royalty-free licence to use the drawings in connection
                    with the relevant property, including if they subsequently appoint another designer or
                    contractor.
                </p>

                <H2>Geography</H2>
                <p>The free design service operates primarily across:</p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>West London;</li>
                    <li>North-West London;</li>
                    <li>South-West London;</li>
                    <li>selected surrounding areas, including parts of Surrey.</li>
                </ul>

                <H2>Legal operator</H2>
                <p>
                    London Renovation Specialists is a trading name of Studio G4 Ltd,
                    a company registered in England and Wales under company number{" "}
                    12308705, with registered office at{" "}
                    10 Barley Mow Passage, Chiswick, London, W4 4PH.
                </p>
            </LegalBody>
        </div>
    );
}
